import React, { useEffect, useState } from "react";
import CreatePublishActivity from "../../Create_Assessment_Activity/create_published/CreatePublishActivity";
import PdfQTypeDRaft from "../../On_going/Draft/Draft_Assess_Box/Draft_Q_list/PdfQTypeDRaft";
import { Link, NavLink, useLocation, useNavigate } from "react-router-dom";
import axios from "../../../../axios";
import { Form } from "react-bootstrap";
// all css comes from ...Draft_Q_list_PreRead.css

export default function ScheduleEdit_Activity() {
  const navigate = useNavigate();
  const [click2, setClick2] = useState(false);
  //Added this state by Kuldeep
  const { state } = useLocation()
  let Teacher_id = localStorage.getItem("Teacher_id");
  let Teacher_Json = JSON.parse(Teacher_id);
  const [updateActivity, setUpdateActivity] = useState({
    description: "",
    updateTittle: "",
    updateTotalMarks: "",
    updateDeadline: "",
    updateScheduleDate: "",
    updateScheduleTime: "",
    difficultyLevel: "",
    attach: [],
  });
  const {
    description,
    updateTittle,
    updateTotalMarks,
    updateDeadline,
    updateScheduleDate,
    updateScheduleTime,
    attach,
    difficultyLevel,
  } = updateActivity;

  const [actiScheduleData, setActiScheduleData] = useState({
    scheduleActivity: [],
  });
  const { scheduleActivity } = actiScheduleData;

  useEffect(() => {
    const getScheduleActivity = async () => {
      try {
        const res = await axios.get(
          `/api/v1/homework/activity/getById/${state.scheduledActivity_id}`
        );
        console.log(res.data.data);
        res &&
          setActiScheduleData({
            scheduleActivity: res.data.data,
          });
        setUpdateActivity({
          ...updateActivity,
          description: res?.data.data.description,
          updateTittle: res?.data.data.name,
          updateTotalMarks: res?.data.data.total_marks,
          attach: res?.data.data.attachments,
          updateDeadline: res?.data.data.deadline,
          updateScheduleDate: res?.data.data.schedule_date,
          updateScheduleTime: res?.data.data.schedule_time,
          difficultyLevel: res?.data?.data?.difficulty_level?.id,
        });
      } catch (error) { }
    };
    getScheduleActivity();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  let createActivityDraft = {
    standard_id: scheduleActivity?.standard_id?.id,
    subject_id: scheduleActivity?.subject_id?.id,
    section_id: scheduleActivity?.section_id?.id,
    book_id: scheduleActivity?.book_id?.id,
    chapter_id: scheduleActivity?.chapter_id?.id,
    difficulty_level: difficultyLevel,
    teacher_id: Teacher_Json,
    status: "draft",
    description: description,
    name: updateTittle,
    total_marks: updateTotalMarks,
    // attach,
    attachments: attach,
    difficulty_level: scheduleActivity?.difficulty_level?.id,
    deadline: updateDeadline,
    schedule_date: updateScheduleDate,
    schedule_time: updateScheduleTime,
  };

  const myFileInput = document.getElementById("attachFile");
  myFileInput?.addEventListener("change", (event) => {
    const file = event.target.files[0];
    const formData = new FormData();
    formData.append("uploadActivityAttachment", file);
    axios
      .post(
        `/api/v1/homework/activity/uploadAttachment/teacherId/${Teacher_Json}`,
        formData
      )
      .then((response) => {
        createActivityDraft.attachments = response.data.data;
        setUpdateActivity({
          ...updateActivity,
          attach: [response.data.data],
        });
      })
      .catch((error) => {
        console.error("Error uploading file:", error);
      });
  });

  const helper = async () => {
    try {
      let res = await axios.post(
        `/api/v1/homework/activity/update/${scheduleActivity.id}`,
        createActivityDraft
      );
      console.log("resfff", res);
      navigate("/PublishedHomeworkActivity");
    } catch (error) {
      console.log(error);
    }
  };

  const isDisableDraft =
    updateActivity.updateTittle === "" || updateActivity.description === "";
  const isDisablePublish =
    updateActivity.updateTotalMarks === "" ||
    updateActivity.updateTittle === "" ||
    updateActivity.description === "";

  const titleRejex = /^\s+/;
  const descriptionRejex = /^\s+/;

  const errors = {};
  if (updateTittle === (titleRejex.test(updateTittle) && updateTittle)) {
    errors.updateTittle = "Tittle can not start with a space";
  }
  if (description === (descriptionRejex.test(description) && description)) {
    errors.description = "Description can not start with a space";
  }

  return scheduleActivity ? (
    <div>
      <div>
        <div className="d-flex align-items-center ">
          <NavLink
            to={`/ScheduleQListActivity`}
            className="link"
            state={{ scheduledActivity_id: state.scheduledActivity_id }}
          >
            <img src="/images/Back Arrow.svg" alt=""></img>
          </NavLink>
          <Link to="/PublishedHomeworkActivity" className="link">
            <span className="open_publish_path">
              &nbsp;{scheduleActivity?.status} / &nbsp;
            </span>
          </Link>
          <NavLink
            to={`/ScheduleQListActivity`}
            className="link"
            state={{ scheduledActivity_id: state.scheduledActivity_id }}
          >
            <span className="open_publish_path">
              {scheduleActivity?.name} /
            </span>
          </NavLink>
          <span className="open_publish_path1">
            &nbsp; Edit {scheduleActivity?.name}
          </span>
        </div>
        <div className="mt-2 publishsub_heading">{scheduleActivity?.name}</div>
        <div className="p-0 col-11">
          <div className="d-flex align-items-center justify-content-between">
            <div className="sub_heading_activityDraft">
              Create fun activity for the students here.
            </div>
            <div>
              <p className="MarksDesgn">Marks</p>
              <input
                id="addMarks"
                value={updateTotalMarks}
                type="number"
                className="form-control  txt_draft3"
                placeholder="Add Marks"
                onChange={(e) =>
                  setUpdateActivity({
                    ...updateActivity,
                    updateTotalMarks: e.target.value,
                  })
                }
              />
            </div>
          </div>
          <div className="ms-5">
            <input
              type="text"
              value={updateTittle}
              maxLength={50}
              placeholder="Enter title"
              className="txt_draft1 mt-3 form-control"
              id="txt-i-first"
              onChange={(e) =>
                setUpdateActivity({
                  ...updateActivity,
                  updateTittle: e.target.value,
                })
              }
            />
            {errors.updateTittle && (
              <span className="error">{errors.updateTittle}</span>
            )}
            <Form.Control
              as="textarea"
              placeholder="Enter Description"
              maxLength={300}
              value={description}
              rows={4}
              className="px-3 py-2 mt-4 txt_draft2"
              onChange={(e) =>
                setUpdateActivity({
                  ...updateActivity,
                  description: e.target.value,
                })
              }
            />
            {errors.description && (
              <span className="error">{errors.description}</span>
            )}

            <div>
              <div>
                <button className="px-3  pt-2 mt-2 d-flex align-items-center justify-content-center activity_draft_attach ">
                  <input
                    type="file"
                    accept=".pdf,.doc,.docx,.jpg,.jpeg,.png"
                    id="attachFile"
                    style={{ display: "none" }}
                    onChange={(e) =>
                      setUpdateActivity({
                        ...updateActivity,
                        attach: e.target.files[0],
                      })
                    }
                  />
                  <label
                    className="d-flex align-items-center justify-content-center "
                    htmlFor="attachFile"
                  >
                    <img alt="" src="/images/Attach.svg" />

                    <span>&nbsp;Attach</span>
                  </label>
                </button>
              </div>
            </div>
            <div className="mt-2 p-1 pdf_draft_activity d-flex">
              {attach && attach[0]?.length !== 0 && (
                <PdfQTypeDRaft
                  setDraftAttach={setUpdateActivity}
                  updateActivity={updateActivity}
                  editAttachData={scheduleActivity}
                  attach={attach}
                />
              )}
            </div>
          </div>
        </div>
        <div className="me-4 mt-6 d-grid gap-2 d-md-flex justify-content-md-end btnHelper">
          <button
            className="btn px-3  py-2 Next_button_draftAct"
            type="button"
            // onClick={handelDraft}
            onClick={() => {
              helper();
            }}
            disabled={isDisableDraft}
          >
            Save as Draft
          </button>
          <button
            className="btn py-2 Next_button_publicAct"
            onClick={(e) => setClick2(true)}
            disabled={isDisablePublish}
          >
            Publish
          </button>
        </div>
      </div>
      {click2 && (
        <CreatePublishActivity
          change={setClick2}
          createpublishActi={scheduleActivity}
          updateActivity={updateActivity}
        />
      )}
    </div>
  ) : (
    <></>
  );
}
